var render, staticRenderFns
import script from "./QTabs.vue?vue&type=script&lang=js&"
export * from "./QTabs.vue?vue&type=script&lang=js&"
import style0 from "./QTabs.vue?vue&type=style&index=0&id=401f4468&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports